var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formName)?_c('InterfaceForm',{attrs:{"form-name":_vm.formName,"title":_vm.title,"submit-button":_vm.submitButton,"prefill-data":_vm.report,"header-color":_vm.headerColor,"force-sub-obj":_vm.forceSubmitObject},on:{"submit":_vm.submitHandler,"close":_vm.closeHandler,"save":_vm.saveHandler}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }